import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import { authHeaders } from 'lib/laravelAuth'
import * as actions from './actions'

// *load ข้อมูล dashboard stock
function* loadCommandCenterDashboardStock(action) {
  const {
    data: { plant_id },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-command-center/info`,
      { plant_id },
      { headers: authHeaders() }
    )

    yield put(actions.loadCommandCenterDashboardStock.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadCommandCenterDashboardStock.failure())
  }
}

// *load division
function* commandCenterLoadDivision(action) {
  const {
    data: { division_id, department_id, section_id, plant_id },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-command-center/division`,
      { division_id, department_id, section_id, plant_id },
      { headers: authHeaders() }
    )

    yield put(actions.commandCenterLoadDivision.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.commandCenterLoadDivision.failure())
  }
}

// *load department
function* commandCenterLoadDepartment(action) {
  const {
    data: { division_id },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-command-center/department`,
      { division_id },
      { headers: authHeaders() }
    )

    yield put(actions.commandCenterLoadDepartment.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.commandCenterLoadDepartment.failure())
  }
}

// *load section
function* commandCenterLoadSection(action) {
  const {
    data: { department_id },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-command-center/section`,
      { department_id },
      { headers: authHeaders() }
    )

    yield put(actions.commandCenterLoadSection.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.commandCenterLoadSection.failure())
  }
}

// *load plant
function* commandCenterLoadPlant(action) {
  const {
    data: { section_id },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-command-center/plant`,
      { section_id },
      { headers: authHeaders() }
    )

    yield put(actions.commandCenterLoadPlant.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.commandCenterLoadPlant.failure())
  }
}

export default function* watchCommandCenterDashboard() {
  yield all([
    takeEvery(
      actions.LOAD_COMMAND_CENTER_DASHBOARD_STOCK.REQUEST,
      loadCommandCenterDashboardStock
    ),
    takeEvery(
      actions.COMMAND_CENTER_DASHBOARD_LOAD_DIVISION.REQUEST,
      commandCenterLoadDivision
    ),
    takeEvery(
      actions.COMMAND_CENTER_DASHBOARD_LOAD_DEPARTMENT.REQUEST,
      commandCenterLoadDepartment
    ),
    takeEvery(
      actions.COMMAND_CENTER_DASHBOARD_LOAD_SECTION.REQUEST,
      commandCenterLoadSection
    ),
    takeEvery(
      actions.COMMAND_CENTER_DASHBOARD_LOAD_PLANT.REQUEST,
      commandCenterLoadPlant
    ),
  ])
}
export {
  loadCommandCenterDashboardStock,
  commandCenterLoadDivision,
  commandCenterLoadDepartment,
  commandCenterLoadSection,
  commandCenterLoadPlant,
}
